import { render, staticRenderFns } from "./RemoveData.vue?vue&type=template&id=7622acb8&"
import script from "./RemoveData.vue?vue&type=script&lang=js&"
export * from "./RemoveData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports